import React, { FC, ReactNode } from "react";
import { LinkButton } from "../../ActionsSelectors/Button";
import Rating, { IRatingProps } from "../../Atoms/Rating/Rating";
import { ILink } from "../../ActionsSelectors";
import { THeading } from "../../../interfaces";

export interface IFeedback {
  /** Current rating (0.0-5.0) */
  rating: number | string;
  /** Count of reviews */
  reviews: number | string;
  /** Link to make a user review */
  link?: ILink;
}

export interface IProductReviewsProps extends IFeedback {
  /** Additional classes for inner components */
  classes?: {
    root?: string;
    rating?: Record<string, unknown>;
    link?: string;
  };
  /** Text for counter */
  linkText?: ReactNode;
  labels?: { reviews?: string };
  onRatingChange?: IRatingProps["onChange"];
}

const ProductReviews: FC<IProductReviewsProps> = ({
  rating = 0,
  reviews = 0,
  link,
  classes = {},
  linkText,
  labels = { reviews: "reviews" },
  onRatingChange,
}) => (
  <div
    className={`review-section ${classes?.root || ""}`}
    data-testid="product-reviews"
  >
    <Rating
      value={rating}
      classes={classes?.rating || null}
      size="sm"
      editable={!!onRatingChange}
      onChange={onRatingChange}
    />
    <LinkButton
      classes={{
        root: classes?.link,
      }}
      as="a"
      {...link}
    >
      {" "}
      {linkText || `${reviews || ""} ${labels?.reviews}`}
    </LinkButton>
  </div>
);

export default ProductReviews;
